import { Button } from '@shared/ui/Button';
import { Card, Muted, Row, Small, Table, TableBox } from '@widgets/ksp-workspace/parts';
import type { KspRdRequirement } from '@entities/ksp/types';

export interface RdRequirementsCardProps {
  canEdit: boolean;
  requirements: KspRdRequirement[];
  proposed: KspRdRequirement[];
  activityLabel: Map<string, string>;
  onPrefill: () => void;
  onConfirmProposed: () => void;
  onAddRequirement: () => void;
  onEditRequirement: (r: KspRdRequirement) => void;
  onRemoveRequirement: (r: KspRdRequirement) => void;
}

export function RdRequirementsCard({
  canEdit,
  requirements,
  proposed,
  activityLabel,
  onPrefill,
  onConfirmProposed,
  onAddRequirement,
  onEditRequirement,
  onRemoveRequirement,
}: RdRequirementsCardProps) {
  return (
    <Card>
      <h3>Связи «работа ↔ комплект РД»</h3>
      <Muted>
        Связь хранится по документу реестра ПТО и переживает переобработку РД. Предложенные связи
        (из количественных привязок РД) в расчёт не идут, пока инженер их не подтвердит. По
        умолчанию нужны оба условия: получение и разрешение к производству.
      </Muted>
      <Row>
        <Button disabled={!canEdit} onClick={onPrefill}>
          Предложить из привязок РД
        </Button>
        <Button disabled={!canEdit || proposed.length === 0} onClick={onConfirmProposed}>
          Подтвердить предложенные ({proposed.length})
        </Button>
        <Button $variant="ghost" disabled={!canEdit} onClick={onAddRequirement}>
          Добавить связь
        </Button>
      </Row>
      <TableBox>
        <Table>
          <thead>
            <tr>
              <th>Работа</th>
              <th>Комплект</th>
              <th>Условия</th>
              <th>Состояние</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {requirements.map((r) => (
              <tr key={r.id}>
                <td>
                  {r.activity_code ?? activityLabel.get(r.activity_id) ?? r.activity_id}{' '}
                  {r.activity_name}
                </td>
                <td>
                  {r.set_code}
                  {!r.document_id && <Small>ожидается в реестре ПТО</Small>}
                </td>
                <td>
                  {[r.needs_receipt && 'получение', r.needs_permit && 'разрешение']
                    .filter(Boolean)
                    .join(' и ')}
                </td>
                <td>
                  {r.status === 'proposed' ? 'Предложена' : 'Подтверждена'}
                  <Small>{r.origin === 'rd_bindings' ? 'из привязок РД' : 'вручную'}</Small>
                </td>
                <td>
                  <Button $size="sm" $variant="ghost" disabled={!canEdit} onClick={() => onEditRequirement(r)}>
                    {r.status === 'proposed' ? 'Проверить' : 'Условия'}
                  </Button>
                  <Button
                    $size="sm"
                    $variant="ghost"
                    disabled={!canEdit}
                    onClick={() => onRemoveRequirement(r)}
                  >
                    Убрать
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableBox>
      {requirements.length === 0 && <Muted>Связей пока нет.</Muted>}
    </Card>
  );
}
